import React from "react";
import ConfirmationModal from "components/ConfirmationModal";

export const FILTERED_CALL_GROUPS_COMPLETE_TITLE = "Filtered Call Groups Complete!";
export const FILTERED_CALL_GROUPS_COMPLETE_MESSAGE =
  "All prioritized filtered call groups have been completed. Return to the filter screen and filter for your next call group assignment.";

/**
 * Shown when Go/Next finds no remaining call groups in the agent's filter pool.
 */
const FilteredCallGroupsCompleteModal = ({ show, onOkay }) => (
  <ConfirmationModal
    show={show}
    onHide={onOkay}
    onConfirm={onOkay}
    hideCancel
    title={FILTERED_CALL_GROUPS_COMPLETE_TITLE}
    body={FILTERED_CALL_GROUPS_COMPLETE_MESSAGE}
    confirmLabel="Okay"
    dataTestId="modal-filtered-call-groups-complete"
  />
);

export default FilteredCallGroupsCompleteModal;
